import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { ToastContainer, toast } from "react-toastify";
import * as helpers from "../../../helpers/helpers";
import http from "../../../helpers/http";
import LoadingScreen from "../../common/LoadingScreen";
import MultiRangeSlider from "../multirangeslider/MultiRangeSlider";
import SearchResultsComponent from "./Result-search";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { setSearchQuery } from "../../../states/actions/searchQueryActions";
import { FETCH_PROPERTIES_CONTENT_FAILED } from "../../../states/actions/actionTypes";
import { toggleResultView } from "../../../states/actions/resultView";
import usePreviousURLParams from "./prevurl";
import NewFiltersForm from "./new-filters-form";

const FiltersSearchNew = (props) => {
  const searchInputRef = useRef(null);
  const [searchParams] = useSearchParams();

  const [search_p, setSearchP] = useState("");
  const [searchQueryValues, setSearchQueryValues] = useState(null);
  const dispatch = useDispatch();

  const location = useLocation();
  const { pathname } = location;
  const segments = pathname.split("/");

  const queryParams = new URLSearchParams(location.search);

  const propertyTypeExists = searchQueryValues?.hasOwnProperty("property_type");
  const [sortValue, setSortValue] = useState("sale_price");

  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);

  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchResultsData, setSearchResultsData] = useState(null);
  const [, setTotalPropertiesRecords] = useState(null);

  const [isLoadingform, setIsLoadingform] = useState(false);

  const searchButtonRef = useRef(null);

  const {
    ToggleHideSearch,
    hideSearch,
    Maptoggle,
    showMap,
    ownertoggle,
    setShowMap,
    search_keyword,
    searchRef,
  } = props;
  const navigate = useNavigate();
  const handlePageClick = (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    const all_url_params = {};
    for (const [key, value] of urlParams.entries()) {
      all_url_params[key] = value;
    }

    const geometry = urlParams.get("geometry");
    if (document.getElementById("outer_properties")) {
      window.scroll({
        top: document.getElementById("outer_properties").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    }

    let formName1 = localStorage.getItem("setPreviousForm");
    setPage(event.selected + 1);
    urlParams.set("page", event.selected + 1);
    urlParams.set("geometry", geometry);
    let all_values = all_url_params;
    all_values = {
      ...all_values,
      page: event.selected + 1,
      host: window.location.hostname,
    };
    // console.log(all_values);
    // Navigate to the new URL with the updated parameters
    window.location.href = `/search-property?${urlParams.toString()}`;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const renderMap = (parcel_ids, filtervalues) => {};

  return (
    <>
      {isLoadingform ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <div className="new_outer_filter_new">
            <div className="contain-fluid">
              <div className="mob_filter_view">
                <div className="colL">
                  <span>Home</span> <span>{">"}</span> <span>Search</span>
                </div>
              </div>

              <NewFiltersForm
                setIsLoadingform={setIsLoadingform}
                setSearchResultsData={setSearchResultsData}
                setTotalPropertiesRecords={setTotalPropertiesRecords}
                setShowSearchResults={setShowSearchResults}
                renderMap={renderMap}
                ownertoggle={ownertoggle}
                hideSearch={hideSearch}
                ToggleHideSearch={ToggleHideSearch}
                showMap={showMap}
                drawnFeatures={props.drawnFeatures}
                setDrawnFeatures={props.setDrawnFeatures}
              />
            </div>
          </div>
          {
            // isLoadingform ? (
            //   <LoadingScreen />
            // ) : (
            showSearchResults && (
              <SearchResultsComponent
                data={searchResultsData}
                handlePageClick={handlePageClick}
                hideSearch={hideSearch}
                ToggleHideSearch={ToggleHideSearch}
                sortValue={sortValue}
                setSortValue={setSortValue}
                handleSubmit={handleSubmit}
                propertyTypeExists={propertyTypeExists}
                searchedPage={page}
                drawnFeatures={props.drawnFeatures}
                setDrawnFeatures={props.setDrawnFeatures}
                Maptoggle={Maptoggle}
                setSearchQueryValues={setSearchQueryValues}
              />
            )
            // )
          }
        </>
      )}
    </>
  );
};

export default FiltersSearchNew;
